import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, inject, watch, Ref } from 'vue';
import CButton from '@/components/shared/CButton';
import CModal from '@/components/CModal.vue';
import CInput from '@/components/shared/CInput.vue';
import { MAP_STYLE_PRESETS } from '@/components/DesignStudio/MapStyleProperties/presets';
import { TippyComponent } from 'vue-tippy';

interface Props {
    id: number;
    item: string;
    readonly?: boolean;
    isDefault: boolean;
}

interface Emits {
    (
        event: 'update',
        data: {
            id: number;
            value: string;
        }
    ): void;
    (event: 'remove', value: string): void;
    (event: 'set-default', value: number): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapStylePropertiesListItem',
  props: {
    id: null,
    item: null,
    readonly: { type: Boolean },
    isDefault: { type: Boolean }
  },
  emits: ["update", "remove", "set-default"],
  setup(__props: any, { emit }: { emit: ({
    (
        event: 'update',
        data: {
            id: number;
            value: string;
        }
    ): void;
    (event: 'remove', value: string): void;
    (event: 'set-default', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    id: number;
    item: string;
    readonly?: boolean;
    isDefault: boolean;
};



const mapBoxPrefix = 'mapbox://styles/';

const isOpen = ref(false);
const newValue = ref(`${mapBoxPrefix}${props.item}`);

const openMapStyleId = inject<Ref<number | null>>('openMapStyleId', ref(null));

watch(
    () => openMapStyleId?.value,
    (val) => {
        if (val && val === props.id) {
            handleOpen();
            openMapStyleId!.value = null;
        }
    }
);

const mapStyle = computed(() => MAP_STYLE_PRESETS.find((preset) => preset.id === props.item));
const isEditable = computed(() => !MAP_STYLE_PRESETS.some((preset) => preset.id === props.item));
const itemLabel = computed(() => (mapStyle.value ? mapStyle.value.label : `Custom Style - ${props.item}`));

const handleClose = () => {
    isOpen.value = false;
};

const handleCancel = () => {
    newValue.value = `${mapBoxPrefix}${props.item}`;
    handleClose();
};

const handleOpen = () => {
    isOpen.value = true;
};

const handleUpdate = async () => {
    emit('update', {
        value: newValue.value.replace(mapBoxPrefix, ''),
        id: props.id
    });
    handleClose();
};

const handleRemove = () => {
    emit('remove', props.item);
};

const handleDefaultStyle = () => {
    emit('set-default', props.id);
};

return { __sfc: true,props, emit, mapBoxPrefix, isOpen, newValue, openMapStyleId, mapStyle, isEditable, itemLabel, handleClose, handleCancel, handleOpen, handleUpdate, handleRemove, handleDefaultStyle, CButton, CModal, CInput, TippyComponent }
}

})